import { combineReducers, configureStore } from '@reduxjs/toolkit';
import loginReducer from 'src/redux/reducers/auth.slice';
import profileReducer from 'src/redux/reducers/profile.slice';
import createDevReducer from 'src/redux/reducers/createDev.slice';
import userReducer from 'src/redux/reducers/user.slice';
import adminUserReducer from 'src/redux/reducers/adminUser.slice';
import developerReducer from 'src/redux/reducers/developer.slice';
import appointmentsReducer from 'src/redux/reducers/appointments.slice';
import bootcampReducer from 'src/redux/reducers/bootcamp.slice';
import chatReducer from 'src/redux/reducers/chat.slice';
import newsletterReducer from 'src/redux/reducers/newsLetter.slice';
import companyReducer from 'src/redux/reducers/company.slice';
import fuse from '../app/store/fuse';
import i18n from '../app/store/i18nSlice';
import chatApp from 'app/main/apps/urbanhive-inbox/store';
import { persistReducer } from 'redux-persist';
import storage from './storage';
import thunk from 'redux-thunk';

const staticReducers = {
  login: loginReducer,
  profile: profileReducer,
  createDev: createDevReducer,
  user: userReducer,
  adminUser: adminUserReducer,
  developer: developerReducer,
  appointments: appointmentsReducer,
  bootcamp: bootcampReducer,
  chat: chatReducer,
  newsletter: newsletterReducer,
  company: companyReducer,
  fuse,
  i18n,
  chatApp,
};

const asyncReducers = {};

function createReducer(extraReducers = {}) {
  return combineReducers({
    ...staticReducers,
    ...extraReducers,
  });
}

const appReducer = (state, action) => {
  const combinedReducer = createReducer(asyncReducers);

  if (action.type === 'auth/user/userLoggedOut') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

const persistConfig = {
  key: 'nurturer-root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, appReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export function injectReducer(key, reducer) {
  if (asyncReducers[key]) {
    return false;
  }

  asyncReducers[key] = reducer;
  store.replaceReducer(persistReducer(persistConfig, appReducer));
  return store;
}

export default store;
